@use '@design/design-tokens/typography/typography' as *;

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.topRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.headerContent {
  display: flex;
  align-items: center;
  gap: 8px;
}

.titleText {
  @include typography-v2-body-md;
}

.subtitleSmall {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.bodySmall {
  @include typography-v2-body-sm;
}
